import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import { GAME_IMAGES_KEY } from '../gameData';

export default class TossItemHalf extends Phaser.GameObjects.Image {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    super(scene, 0,0, GAME_IMAGES_KEY, 'Num1_1');

    this.rotationSpeed = null;
    this.gravity = 800;
    this.vX = null;
    this.vY = null;
  }

  reset (itemBaseName, direction, startX, startY) {
    this.setFrame(`${itemBaseName}_${direction}`);
    this.x = startX;
    this.y = startY;
    this.angle = 0;
    let min;
    let max;
    if (direction === 1) {
      min = -180.00;
      max = 90.00;
    }
    else {
      min = -90.00;
      max = 180.00;
    }

    const v = Phaser.Math.Between(min,max);
    this.vX = Math.cos(Math.PI / 90) * v;
    this.vY = Math.sin(Math.PI / 90) * v;
    this.rotationSpeed = Phaser.Math.Between(30,50);
  }

  tick (deltaMs) {
    const delta = deltaMs / 1000;
    this.vY += delta * this.gravity;
    this.x += delta * this.vX;
    this.y += delta * this.vY;
    this.angle += delta * this.rotationSpeed;
  }
}